import { useState, useCallback, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { updateLeadStatus } from '../api'
import { ILeadStatusUpdate } from '../typings'

export const useUpdateLeadStatus = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [toUpdate, setToUpdate] = useState<ILeadStatusUpdate>()
  const execute = useCallback(
    (update: ILeadStatusUpdate) => {
      if (status != 'pending') {
        setToUpdate(update)
      }
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (toUpdate) {
        try {
          setStatus('pending')
          const result = await dispatch(updateLeadStatus(toUpdate))

          if (mounted) {
            if (updateLeadStatus.fulfilled.match(result)) {
              setStatus('success')
              if (toUpdate.salesFunnelStageName === 'Disqualified')
                toast.success('Lead Disqualified')
            } else {
              setStatus('fail')
              toast.error('Unable to update lead status')
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
            toast.error(error.Message)
          }
        } finally {
          setToUpdate(undefined)
          setStatus('idle')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, toUpdate])

  return { status, execute }
}
